import React, { useRef } from "react";
import cameraIcon from "../../Images/camera.svg";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";

function RenderProductsVariantsListImage({
  isSubmitting,
  handleChangeimage1920,
  data,
  fullName,
  index,
  setFieldValue,
  editableIndex,
}) {
  const image1920Ref = useRef();
  // console.log("editableIndex,index", editableIndex, index);
  return (
    <div
      className="col-12 col-md-4 product_variant_image_container"
      onClick={() => {
        if (editableIndex === index) image1920Ref.current.click();
      }}
    >
      <UploadedImage src={data.image_1920 || cameraIcon} />
      <input
        ref={image1920Ref}
        type="file"
        name={fullName}
        hidden
        accept="image/*"
        onChange={(e) =>
          handleChangeimage1920(e, index, data, setFieldValue, fullName)
        }
      />
    </div>
  );
}

export default RenderProductsVariantsListImage;
